/*
 * @Description: 跟进管理模块数据字典
 * @Author: mdb
 * @Date: 2022-07-19 10:48:56
 * @LastEditTime: 2022-09-06 18:02:43
 * @LastEditors: mdb
 */

// 计划状态枚举
export const planStatusEnum = [
  { label: '未开始', value: 1, color: '#1D4CD2' },
  { label: '已结束', value: 2, color: '#EF8D3C' },
  { label: '已完成', value: 3, color: '#3FAC46' }
]
// 访客提醒枚举
export const remindTypeEnum = [
  { label: '不提醒', value: 1 },
  { label: '提前1小时提醒', value: 2 },
  { label: '提前1天提醒', value: 3 },
  { label: '其它时间', value: 4 }
]

export default { planStatusEnum, remindTypeEnum }
